const HTML_TAG_PATTERN = /<\/?[a-zA-Z][\w:-]*(\s[^<>]*)?>/;

export function hasHtmlMarkup(value: string): boolean {
  return HTML_TAG_PATTERN.test(value);
}
